import tw from "twin.macro";
import styled from "styled-components";

export const SectionHeading = styled.h2`
  ${tw`text-4xl sm:text-5xl font-black tracking-wide text-center`}
  font-family: 'Cormorant Garant', serif;
  color: #0C2A29;
`;

export const Subheading = styled.h5`
  ${tw`font-bold`}
  font-family: 'Nunito', sans-serif;
  color: #2A9D8F;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.8rem;
`;
